import { MemberDetailsDto } from '../listtones/memberdetailsdto';

export interface CreateGroupDto
{
    getAPartyMsisdn(): string;
    getGroupName(): string;
    getGroupDesc(): string;
    getMemberDetails(): MemberDetailsDto[]; // TODO JsonObjectList
    getToneDetails(): string;
    getPriority(): string;
}

export class CreateGroupDtoImpl implements CreateGroupDto
{
    private aPartyMsisdn: string;
    private groupName: string;
    private groupDesc: string;
    private memberDetails: MemberDetailsDto[];
    private toneDetails: string;
    private priority: string;

    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }
    getAPartyMsisdn(): string
    {
        return this.aPartyMsisdn;
    }

    setGroupName(groupName: string)
    {
        this.groupName = groupName;
    } 
    getGroupName(): string 
    {
        return this.groupName;
    }

    getGroupDesc(): string
    {
        return this.groupDesc;
    }
    setGroupDesc(groupDesc: string)
    {
        this.groupDesc = groupDesc;
    }

    setMemberDetails(memberDetails: MemberDetailsDto[])
    {
        this.memberDetails = memberDetails;
    }
    getMemberDetails(): MemberDetailsDto[] 
    {
        return this.memberDetails;
    }   

    setToneDetails(toneDetails: string)
    {
        this.toneDetails = toneDetails;
    }
    getToneDetails(): string 
    {
        return this.toneDetails;
    }   

    setPriority(priority: string)
    {
        this.priority = priority;
    }
    getPriority(): string 
    {
        return this.priority;
    }   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/creategroup/creategroupdto.ts